import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CybersecurityPage from "../pages/services/cybersecurity/page";
import AboutPage from "../pages/about/page";
import NewYorkLocationPage from "../pages/locations/new-york/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services/cybersecurity",
    element: <CybersecurityPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/locations/new-york",
    element: <NewYorkLocationPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
